import { render, staticRenderFns } from "./ConfirmWindow.vue?vue&type=template&id=27a10416&scoped=true&"
import script from "./ConfirmWindow.vue?vue&type=script&lang=js&"
export * from "./ConfirmWindow.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmWindow.vue?vue&type=style&index=0&id=27a10416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a10416",
  null
  
)

export default component.exports